/* Import Utils */
import { elementExists, slideUp, slideDown } from '../util/_utilities';

// Variable that holds all classes used in the script
const classes = {
    // Class that is added/removed to set a sub menu as active.
    activeSubmenu: 'rs-navigation__sub--active'
};

// Variable that holds all elements used in the script
const elements = {
    // body Element
    bodyElement: document.body,
    // Header Element
    headerElement: document.querySelector('.rs-header'),
    // Header Element
    headerMainBarElement: document.querySelector('.rs-header__main'),
    // Main Menu Container
    mainMenuElement: document.querySelector('.rs-navigation'),
    // Sub menu container
    subMenuElement: document.querySelector('.rs-navigation__sub'),
    // Top Level Menu Items
    topLevelMenuItems: document.querySelectorAll('.rs-navigation__menu-item')
};

// Currently open submenu
const currentSubMenu = {
    open: false, // Flag if the menu is open or closed.
    id: 1, // Current ID for the active sub menu
    element: '', // Current element for the active sub menu.
    parent: '' // Current main menuelement for the active sub menu.
};

// Main exportable function. Will call the MobileMenu functionality and the stickyHeader functionality
export function siteHeader () {
    // Make sure mainMenu exists.
    if (
        elementExists(elements.headerElement) &&
                elementExists(elements.mainMenuElement)
    ) {
        // elements.subMenu is required for the logic to work
        if (elementExists(elements.subMenuElement)) {
            // Desktop Menu Functions
            setupDesktopSubMenu();
        }
    }
}

/* =============================================================================
Desktop Setup
============================================================================= */
function setupDesktopSubMenu () {
    // Add event watchers to open/switch the sub menus.
    desktopOpenSubMenu();
    desktopCloseSubMenu();
}

/* =============================================================================
Desktop Sub Menu Watchers
============================================================================= */
// Adds watchers to each top level menu item to open the menu
function desktopOpenSubMenu () {
    // Check to make sure there are top level menu items.
    if (elements.topLevelMenuItems.length > 0) {
        elements.topLevelMenuItems.forEach(menuItem => {
            // When the mouse enters the list item check to open the sub menu.
            menuItem.addEventListener('mouseenter', event => {
                updateCurrentSubMenu(
                    event.target.getAttribute('data-menu-number')
                );
                setActiveTopMenu();
                setActiveSubMenu();

                if (
                    event.target.classList.contains(
                        'item_has_children'
                    ) &&
                    (!currentSubMenu.open ||
                        elements.subMenuElement.style.display === 'none')
                ) {
                    // If the menu is not already open open it now
                    openSubMenu();
                }
            });
            // When the mouse leaves the list item, check to remove the active class.
            menuItem.addEventListener('mouseleave', event => {
                if (
                    event.target.classList.contains(
                        'item_no_children'
                    )
                ) {
                    disableActiveTopMenu();
                    closeSubMenu();
                    currentSubMenu.open = false;
                }
            });
        });
    }
}
function desktopCloseSubMenu () {
    // Check to make sure there are top level menu items.
    if (elementExists(elements.headerElement)) {
        elements.headerElement.addEventListener('mouseleave', event => {
            // If the menu is open it now, close it
            if (currentSubMenu.open) {
                closeSubMenu();
                disableActiveTopMenu();
            }
        });
    }
}

/* =============================================================================
Sub Menu Actions
============================================================================= */
// Opens the sub menu
function openSubMenu () {
    if (elementExists(elements.subMenuElement)) {
        slideDown(elements.subMenuElement, 250, () => {
            currentSubMenu.open = true;
        });
    }
}
// Closes the sub menu
function closeSubMenu () {
    if (elementExists(elements.subMenuElement)) {
        slideUp(elements.subMenuElement, 250, () => {
            currentSubMenu.open = false;
        });
    }
}

/* =============================================================================
Active Sub Menu Activation
============================================================================= */
// Get the currently open submenu
function updateCurrentSubMenu (subMenuID) {
    if (subMenuID) {
        currentSubMenu.id = subMenuID;
        currentSubMenu.element = elements.subMenuElement.querySelector(
            '[data-menu-number="' + subMenuID + '"]'
        );
        currentSubMenu.parent = elements.mainMenuElement.querySelector(
            '[data-menu-number="' + subMenuID + '"]'
        );
    } else {
        currentSubMenu.id = false;
        currentSubMenu.element = null;
        currentSubMenu.parent = null;
    }
}
// Set the active top level menu item (and update the indicator)
function setActiveTopMenu () {
    disableActiveTopMenu();

    if (elementExists(currentSubMenu.parent)) {
        currentSubMenu.parent.classList.add(classes.activeSubmenu);
    }
}
// Set the active top level menu item (and update the indicator)
function disableActiveTopMenu () {
    // if there are active menus, loop them.
    if (elements.topLevelMenuItems.length > 0) {
        elements.topLevelMenuItems.forEach(activeMenu => {
            activeMenu.classList.remove(classes.activeSubmenu);
        });
    }
}
// Handle the logic to transition a sub menu from another one
function setActiveSubMenu () {
    // Check to make sure the current element exsists
    if (elementExists(currentSubMenu.element)) {
        // get active menus.
        const activeMenus = elements.subMenuElement.querySelectorAll(
            '.rs-navigation__sub__menu'
        );
        // if there are active menus, loop them.
        if (activeMenus.length > 0) {
            activeMenus.forEach(activeMenu => {
                activeMenu.classList.remove(classes.activeSubmenu);
            });
        }
        currentSubMenu.element.classList.add(classes.activeSubmenu);
    } else {
        closeSubMenu();
    }
}
